import { useCallback, useState } from "react"
import { Button } from "react-bootstrap"
import { FaRegCalendarCheck } from "react-icons/fa"
import RandomSchedulingExclusionsModal, { DaysToExcludeExt } from "./RandomSchedulingExclusionsModal"

export interface DatesToExcludeModalProps {
  daysExcluded: DaysToExcludeExt[]
  poolID: number
  classNameButton?: string
  onSave: (list: DaysToExcludeExt[]) => void
}

const DatesToExcludeModal = (props: DatesToExcludeModalProps) => {
  const { daysExcluded, poolID, classNameButton, onSave } = props
  const [show, setShow] = useState(false)

  const handleSave = useCallback((list: DaysToExcludeExt[]) => {
    setShow(false)
    onSave(list)
  }, [onSave])

  return (
    <>
      <Button variant="link"
        className={`text-uppercase ${classNameButton}`}
        onClick={() => setShow(true)}>
        <span className="small">add dates <FaRegCalendarCheck className="inline-block mb-1 p-0" /></span>
      </Button>
      {show && <RandomSchedulingExclusionsModal
        daysToExclude={daysExcluded}
        poolID={poolID}
        onCancel={() => setShow(false)}
        onSave={handleSave} />}
    </>
  )
}

export default DatesToExcludeModal
